module.exports = __webpack_public_path__ + "img/Winzig.0db15a70.svg";